export default "__VITE_ASSET__Beaz5ANt__"